<div class="container">
  <div class="row justify-content-center mt-3">
    <h3>Mapping</h3>
    <div class="col-md-12 mb-2">
      <div ngbDropdown class="d-inline-block" placement="bottom">
        <label class="form-label" for="vendorSelector">Selected Vendor:</label>
        <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>
          {{ getSelectedVendorName() }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button *ngFor="let vendor of vendorIdList" class="dropdown-item" (click)="selectVendor(vendor)">
            {{ vendor.name }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-12 mb-2">
      <div ngbDropdown class="d-inline-block" placement="bottom">
        <label class="form-label" for="taxonomySelector">Selected Taxonomy:</label>
        <button class="btn btn-outline-primary" id="dropdownBasic2" ngbDropdownToggle>
          {{ selectedTaxonomy || 'Select Taxonomy' }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
          <button *ngFor="let taxonomy of taxonomyList" class="dropdown-item" (click)="selectTaxonomy(taxonomy)">
            {{ taxonomy }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-12" *ngIf="selectedTaxonomy && selectedVendor">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="flexCheckDefault"
          [ngModel]="isUnmappedOnly" (ngModelChange)="isUnmappedOnly = $event; onUnmappedToggle()">
        <label class="form-check-label" for="flexCheckDefault">
          Show only unmapped items
        </label>
      </div>
      <div class="form-check" *ngIf="isSizeMapping()">
        <input class="form-check-input" type="checkbox" id="flexCheckGeneralBrand"
          [checked]="isGeneralBrandOnly" (change)="onGeneralBrandToggle($any($event.target).checked)">
        <label class="form-check-label" for="flexCheckGeneralBrand">
          General brand
        </label>
      </div>
      <div class="form-check" *ngIf="isSizeMapping()">
        <input class="form-check-input" type="checkbox" id="flexCheckBrandSpecific"
          [checked]="isBrandSpecificOnly" (change)="onBrandSpecificToggle($any($event.target).checked)">
        <label class="form-check-label" for="flexCheckBrandSpecific">
          Brand specific
        </label>
      </div>
    </div>
    <div class="col-md-12" *ngIf="selectedTaxonomy && selectedVendor">
      <div class="form-check custom-align-right">
        <button class="btn btn-outline-secondary me-2" (click)="navigateToBrandMappingManagement()">
          Manage Brand Size Mappings
        </button>
        <button class="btn btn-outline-primary" (click)="updateProducts()">
          Update products
        </button>
      </div>
    </div>
  </div>
  <div class="row data pb-4" *ngIf="selectedTaxonomy && selectedVendor">
    <!-- Vendor List -->
    <div class="col-sm-6">
      <div class="sticky-top pb-2">
        <h5 class="vendor-list-heading">
          Vendor List
          <small *ngIf="isLoading" class="text-muted ms-2">Loading…</small>
        </h5>
        <div class="list-search-wrapper">
          <input class="form-control list-search-input" type="text"
            [ngModel]="vendorSearchTerm" (ngModelChange)="onVendorSearchChange($event)"
            placeholder="Search vendor items..." />
          <button *ngIf="vendorSearchTerm" type="button" class="btn btn-sm btn-link list-search-clear"
            (click)="clearVendorSearch()" title="Clear search">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
      <div class="card list-card vendor-list-card">
        <div class="vendor-list vertical-tab">
          <div class="list-item nav-item"
            *ngFor="let vendorItem of filteredVendorItemList; trackBy: trackByVendorItem">
            <div class="button-container">
              <div class="nav-link" [class.active]="vendorItem?.id === selectedVendorItem?.id"
                (click)="selectVendorItem(vendorItem)">
                <div class="vendor-item-info">
                  <img *ngIf="vendorItem.systemItemId !== 0" class="check-icon"
                    src="../../../../assets/images/check.png" alt="V Icon" />
                  <span class="vendor-item-name">{{ vendorItem?.idName }}</span>
                  <span *ngIf="vendorItem?.systemItemValue !== null" class="vendor-item-value">
                    &ndash; <b>{{ vendorItem?.systemItemValue }}</b>
                  </span>
                  <span class="mapped-brand-name" *ngIf="isSizeMapping() && getMappedBrandName(vendorItem)">
                    {{ getMappedBrandName(vendorItem) }}
                  </span>
                </div>
                <div class="icon-container">
                  <div ngbDropdown class="d-inline-block brand-action-group" placement="bottom-end" container="body"
                    *ngIf="isSizeMapping() && vendorItem.systemItemId !== 0">
                    <button class="btn btn-outline-success btn-sm brand-map-btn" ngbDropdownToggle
                      (click)="openBrandPicker(vendorItem); $event.stopPropagation()"
                      title="Create brand-specific mapping">
                      <i class="fa fa-tag me-1"></i> Map brand
                    </button>
                    <div ngbDropdownMenu class="brand-dropdown-menu row-brand-dropdown"
                      (click)="$event.stopPropagation()">
                      <button *ngFor="let brand of availableBrands" class="dropdown-item row-brand-item"
                        (click)="createBrandSpecificForSelectedBrand(vendorItem, brand)">
                        {{ brand.name }}
                      </button>
                    </div>
                  </div>
                  <i *ngIf="isSizeMapping() && selectedBrand && vendorItem.systemItemId !== 0 && isBrandSpecificMapped(vendorItem)"
                    class="fa fa-trash-o fa-2x x-mark-icon"
                    (click)="removeBrandSpecificMapping(vendorItem); $event.stopPropagation()"
                    title="Delete brand-specific mapping"></i>
                  <i *ngIf="vendorItem.systemItemId !== 0" class="fa fa-times-circle-o fa-2x x-mark-icon"
                    (click)="removeVendorItemMapping(vendorItem)"></i>
                  <i class="fa fa-image fa-image-icon" (click)="openVerticallyCentered(content, vendorItem)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Master List -->
    <div class="col-sm-6">
      <div class="sticky-top pb-1">
        <h5>Master List</h5>
        <div class="list-search-wrapper">
          <input class="form-control list-search-input" type="text"
            [ngModel]="masterSearchTerm" (ngModelChange)="onMasterSearchChange($event)"
            placeholder="Search master items..." />
          <button *ngIf="masterSearchTerm" type="button" class="btn btn-sm btn-link list-search-clear"
            (click)="clearMasterSearch()" title="Clear search">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
      <div class="card list-card">
        <cdk-virtual-scroll-viewport [itemSize]="masterItemSize" minBufferPx="240" maxBufferPx="480"
          [style.height.px]="masterViewportHeight" class="virtual-list virtual-list--master vertical-tab">
          <div class="list-item nav-item"
            *cdkVirtualFor="let masterItem of filteredMasterItemList; trackBy: trackByMasterItem">
            <div class="button-container">
              <div class="nav-link master-nav-link" [class.active]="masterItem?.id === selectedMasterItem?.id"
                (click)="selectMasterItem(masterItem)">{{ masterItem?.name }}</div>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>

  <ng-template #content let-modal>
    <div class="modal-header" style="border-bottom: 0px">
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body" style="padding: 0%">
      <app-photo-carousel [relatedProducts]="relatedProducts"></app-photo-carousel>
    </div>
  </ng-template>

</div>